import { useState } from "react";
import "./videos.css";

const testimonialVideo = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/videos/sentry-road.mp4";
const thumbnail = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/videos/sentry-thumbnail.webp";


const SentryVideoTestimonial = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayVideo = () => {
        setIsPlaying(true);
    };

    return (
        <div className="video-container p-lg-5 px-3 py-4">
            {isPlaying ? (
                <video width="100%" height="auto" controls autoPlay>
                    <source src={testimonialVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    loading="lazy"
                    className="video-thumbnail"
                    onClick={handlePlayVideo}
                />
            )}
        </div>
    );
};

export default SentryVideoTestimonial;
